import { useEffect, useState } from 'react';
import { getSubscriptions } from '../../lib/use-cases/get-subscriptions';
import { cancelSubscription } from '../../lib/use-cases/cancel-subscription';

function useSubscriptions() {
    const [subscriptions, setSubscriptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isPending, setIsPending] = useState(false);
    const [preCancelData, setPreCancelData] = useState({});

    const getData = async () => {
        const list = await getSubscriptions();

        setSubscriptions(list);
        setIsLoading(false);
    };

    const handleCancelSubscription = afterCallback => async () => {
        try {
            setIsPending(true);

            await cancelSubscription(preCancelData.id);

            afterCallback();
            getData();
        } catch (e) {
            alert(e?.message || 'Failed cancel subscription'); /* eslint-disable-line */
        } finally {
            setIsPending(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return {
        subscriptions,
        websiteExtendedSubscription: subscriptions.find(s => s.isActive && s.features.includes('websiteExtended')),
        cancelSubscription: handleCancelSubscription,
        preCancelData,
        setPreCancelData,
        isPending,
        isLoading
    };
}

export {
    useSubscriptions
};
